import { createPortal } from "react-dom";
import styled from "styled-components";
import { ContentContainer } from "./ContentContainer";
import { Button } from "../controls/Button";
import { MaterialIcon } from "../shared/MaterialIcon";

export const ModalContainer = ({title, description, submitText, onSubmit, discardText, onDiscard, children}) => {
    return (
        createPortal(
            <StyledModalContainer>
                <ContentContainer padding='none'>
                    <div className="modalHeader">
                        <div className="text">
                            <div className="title">{title}</div>
                            {description ? <div className="description">{description}</div> : null}
                        </div>
                        <MaterialIcon
                            name='close'
                            weight={300}
                            size='md'
                            onClick={() => onDiscard?.()}
                        />
                    </div>
                    <div className="modalContent">
                        {children}
                    </div>
                    <div className="modalFooter">
                        <Button
                            type="secondary"
                            text={discardText}
                            onClick={onDiscard}
                        />
                        <Button
                            type="primary"
                            text={submitText}
                            onClick={onSubmit}
                        />
                    </div>
                </ContentContainer>
            </StyledModalContainer>,
            document.getElementById("modalRoot")
        )
    )
}

const StyledModalContainer = styled.div`
    height: 100%;
    width: 100%;
    z-index: 5000;
    background: rgba(${({theme}) => theme.colors.neutralSecondaryForegroundRGB}, 0.75);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;

    > div
    {
        min-width: 400px;
    }

    div.modalHeader
    {
        padding: ${({theme}) => theme.spacing.lg};
        display: flex;
        justify-content: space-between;
        align-items: top;
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};

        div.text
        {
            user-select: none;
            display: flex;
            flex-direction: column;
            gap: ${({theme}) => theme.spacing.sm};

            div.title
            {
                font-weight: 600;
                font-size: ${({theme}) => theme.fontSize.lg};
            }

            div.description
            {
                color: ${({theme}) => theme.colors.mutedForeground};
            }
            
        }

        .icon
        {
            color: ${({theme}) => theme.colors.mutedForeground};
            cursor: pointer;
        }
    }

    div.modalContent
    {
        padding: ${({theme}) => theme.spacing.lg};
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};
    }

    div.modalFooter
    {
        border-top: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        padding: ${({theme}) => theme.spacing.lg};
        display: flex;
        gap: ${({theme}) => theme.spacing.md};
        justify-content: flex-end;
    }
`